// Value model PhoneInputComponent exposes through its ControlValueAccessor contract — this exact
// shape is both the internal state and what a formControlName bound to it reads/writes.
export interface PhoneValue {
  countryId: number | null;
  number: string;
}

export const EMPTY_PHONE_VALUE: PhoneValue = { countryId: null, number: '' };
